import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'
import roundedCheck from 'assets/icons/roundedCheck.svg'
import Loader from 'components/shared/Loader'

interface CodeValidProps {
    promoCode?: string
    isLoading?: boolean
}

const CodeValid = ({ promoCode, isLoading }: CodeValidProps) => (
    <Box direction="row" gap={8}>
        {isLoading ? (
            <Loader />
        ) : (
            <>
                <img src={roundedCheck} alt="rounded green checkmark" />
                <Text variant="bodyStrong" color="success">
                    <FormattedMessage
                        id="order.discount.application_confirmation"
                        defaultMessage="Zastosowano kod rabatowy <code></code>"
                        values={{
                            code: () => (
                                <>
                                    {!!promoCode && (
                                        <Text
                                            as="span"
                                            variant="bodyStrong"
                                            color="success"
                                        >
                                            {` ${promoCode}`}
                                        </Text>
                                    )}
                                </>
                            ),
                        }}
                    />
                </Text>
            </>
        )}
    </Box>
)

export default CodeValid
